import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import SectionCard from "./SectionCard";

const DataTableShell = ({
  title,
  subtitle,
  actions,
  children,
  className,
  sx,
  ...props
}) => {
  return (
    <SectionCard className={className} sx={sx} {...props}>
      {(title || subtitle || actions) && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          sx={{ mb: 1.5 }}
        >
          <Box>
            {title && <Typography variant="h6">{title}</Typography>}
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions ? <Box>{actions}</Box> : null}
        </Stack>
      )}
      <Box sx={{ width: "100%", overflowX: "auto" }}>{children}</Box>
    </SectionCard>
  );
};

export default DataTableShell;
